import { Box, BoxProps, smBumps } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { TKeyBuilder } from '../../../infrastructure/internationalisation'
import {
  FormConfig,
  getFormats,
  InputConfig,
  useConfig,
} from '../../../state/configuration'
import { getInput } from '../maps'
import { getValidationRules } from '../validation'
import { ErrorMessage } from './ErrorMessage'

interface FormElementProps extends BoxProps {
  item: InputConfig
  config: FormConfig
  controllerName: string
  errorClassName?: string

  tKey: TKeyBuilder
  t: TFunction
}

export const FormElement: FunctionComponent<FormElementProps> = ({
  t,
  tKey,
  config,
  controllerName,
  errorClassName,
  item: { type, meta, name, validation, conditional },
  ...props
}) => {
  const formatsConfig = useConfig(getFormats)
  const { control } = useFormContext()

  const Input = getInput(type)

  const errorId = `${controllerName}_error`

  return (
    <Box width={1} {...props}>
      <Controller
        name={controllerName}
        control={control}
        shouldUnregister={!conditional?.preserve}
        rules={{
          validate: getValidationRules(type, validation, config, formatsConfig),
        }}
        render={({ field: { ref: _, ...field } }) => (
          <Input
            {...field}
            aria-describedby={errorId}
            aria-labelledby={`${controllerName}_header`}
            meta={meta}
            validation={validation}
            errorMessageClass={errorClassName}
            tKey={tKey}
            tName={name}
            t={t}
          />
        )}
      />
      {Boolean(errorClassName) && (
        <ErrorMessage
          id={errorId}
          name={controllerName}
          t={t}
          tKey={tKey}
          tName={name}
          className={errorClassName}
          pt={smBumps}
        />
      )}
    </Box>
  )
}
